const MarketPlace = ()=>import("./MarketPlace.vue");

const moduleRoute = {
    path: "/market_place",
    component:MarketPlace,
}
export default router=>{
    router.addRoutes([moduleRoute]);
}